<template>
	<div>
		<div class="userWrapper">
			<p class="white">以下信息是测评结果的重要依据，也是测评报告的组成部分，请务必如实填写。</p>
			<div class="info-list">
				<span class="fl info-desc">孩子的名字</span>
				<input type="text" class="info-input fr childrenName"/>
			</div>
			<div class="info-list">
				<span class="fl info-desc">孩子的性别</span>
				<span class="icon fr icon-you">&#xe636;</span>
				<p class="info-input fr trigger1">{{sex | sex}}</p>
			</div>
			<div class="info-list">
				<span class="fl info-desc">孩子的生日</span>
				<span class="icon fr icon-you">&#xe636;</span>
				<input type="text" class="info-input fr birthday" readonly id="demo_date"/>
			</div>
      <div class="info-list">
      	<span class="fl info-desc">居住地</span>
        <span class="icon fr icon-you">&#xe636;</span>
      	<p class="info-input fr trigger2">{{living_place}}</p>
      </div>
      <div class="info-list">
      	<span class="fl info-desc">父亲受教育程度</span>
        <span class="icon fr icon-you">&#xe636;</span>
      	<p class="info-input fr trigger3">{{birth_height | edu}}</p>
      </div>
      <div class="info-list">
      	<span class="fl info-desc">母亲受教育程度</span>
        <span class="icon fr icon-you">&#xe636;</span>
      	<p class="info-input fr trigger4">{{birth_weight | edu}}</p>
      </div>
			<!-- <div class="info-list">
				<span class="fl info-desc">出生孕周</span>
				<span class="fr" style="color:rgba(153, 153, 153, 1)">周</span>
				<input type="text" class="info-input fr birth_week" v-bind:value="birth_week"  />
			</div>
			<div class="info-list">
				<span class="fl info-desc">出生体重</span>
				<span class="fr" style="color:rgba(153, 153, 153, 1)">kg</span>
				<input type="text" class="info-input fr birth_weight" v-bind:value="birth_weight"  />
			</div>
			<div class="info-list">
				<span class="fl info-desc">出生身高</span>
				<span class="fr" style="color:rgba(153, 153, 153, 1)">cm</span>
				<input type="text" class="info-input fr birth_height" v-bind:value="birth_height"  />
			</div> -->
			<div class="save-children" @click="saveChild()">保存孩子信息</div>
		</div>
		<bottomBar :bottom="bottom"></bottomBar>
	</div>
</template>

<script>
	import bottomBar from '../components/bottomBar.vue'
	export default {
		data() {
			return {
				bottom: 2,
				childrenName:'',
				role:'',
				sex:'',
				birthday:'',
				birth_week:'',
				birth_weight:'',
				birth_height:'',
				children:'',
				name:'',
				id:'',
        living_place:'',
			}
		},
		created: function() {
			this.children = JSON.parse(localStorage.getItem('user'));
			if(localStorage.getItem('user')==null || localStorage.getItem('user') == undefined){
				this.$router.push({name:'login'});
			}
			if(this.$route.params.id!=undefined){
				document.title = '修改孩子信息';
				this.id = this.$route.params.id;
				var user = this.children;
				this.role = user.role;
				this.sex = user.children.data[this.id].sex;
				this.birthday = user.children.data[this.id].birthday;
        console.log(this.birthday)

				this.birth_week = user.children.data[this.id].birth_week;
				this.birth_weight = parseInt(user.children.data[this.id].birth_weight);
				this.birth_height = parseInt(user.children.data[this.id].birth_height);
        // 小美课程
        this.living_place = user.children.data[this.id].living_place;

				setTimeout(()=>{
					$('.childrenName').val(user.children.data[this.id].name);
				})
			}else{
				document.title = '添加孩子';
			}
		},
		mounted:function(){

		},
		filters: {
            sex: function (value) {
                if(value==1){
                		return '男'
                }else if(value==2){
                		return '女'
                }else{
                		return '';
                }
            },
            edu: function (value) {
                var edu = ''
                switch(value){
                  case 0:
                    edu = '小学';
                    break;
                  case 1:
                    edu = '初中';
                    break;
                  case 2:
                    edu = '高中';
                    break;
                  case 3:
                    edu = '大专';
                    break;
                  case 4:
                    edu = '本科';
                    break;
                  case 5:
                    edu = '研究生';
                    break;
                  case 6:
                    edu = '博士';
                    break;
                }
                return edu;
            }
        },
		methods: {
			trigger1:function(){
				var that = this;
				if(this.sex == 1){
					var sex = 0;
				}else if(this.sex==2){
					var sex = 1;
				}else{
					var sex = 0;
				}
				var mobileSelect1 = new MobileSelect({
					    trigger: '.trigger1',
					    title: '孩子性别',
					    wheels: [
					                {data: ['男','女']}
					            ],
					    position:[sex], //初始化定位 打开时默认选中的哪个 如果不填默认为0
					    transitionEnd:function(indexArr, data){

					    },
					    callback:function(indexArr, data){

					    		if(data[0]=='男'){
						    		that.sex=1;
						    	}else{
						    		that.sex = 2;
						    	}


					    }
					});
			},
      trigger2:function(){
        var city = province;
        var data = [];
        var index = '';
        for(var i=0;i<province.length;i++){
          if(this.living_place == province[i]){
            index = i;
          }
          data.push(city[i].name);
        }
      	var that = this;
      	var mobileSelect2 = new MobileSelect({
      		    trigger: '.trigger2',
      		    title: '选择居住地',
      		    wheels: [
      		                {data: data}
      		            ],
      		    position:[index], //初始化定位 打开时默认选中的哪个 如果不填默认为0
      		    transitionEnd:function(indexArr, data){

      		    },
      		    callback:function(indexArr, data){
                  that.living_place = data[0];
      		    }
      		});
      },
      trigger3:function(){
        //小美医生课程
      	var that = this;
      	var mobileSelect3 = new MobileSelect({
      		    trigger: '.trigger3',
      		    title: '选择受教育水平',
      		    wheels: [
      		                {data: ['小学','初中','高中','大专','本科','研究生','博士']}
      		            ],
      		    position:[this.birth_height], //初始化定位 打开时默认选中的哪个 如果不填默认为0
      		    transitionEnd:function(indexArr, data){

      		    },
      		    callback:function(indexArr, data){

                  switch(data[0]){
                    case '小学':
                      that.birth_height = 0;
                      break;
                    case '初中':
                      that.birth_height = 1;
                      break;
                    case '高中':
                      that.birth_height = 2;
                      break;
                    case '大专':
                      that.birth_height = 3;
                      break;
                    case '本科':
                      that.birth_height = 4;
                      break;
                    case '研究生':
                      that.birth_height = 5;
                      break;
                    case '博士':
                      that.birth_height = 6;
                      break;
                  }
                  // console.log(1,this.birth_height);
                  // console.log(1,this.birth_weight);
      		    }
      		});
      },
      trigger4:function(){
        //小美医生课程
      	var that = this;
      	var mobileSelect4 = new MobileSelect({
      		    trigger: '.trigger4',
      		    title: '选择受教育水平',
      		    wheels: [
      		                {data: ['小学','初中','高中','大专','本科','研究生','博士']}
      		            ],
      		    position:[this.birth_weight], //初始化定位 打开时默认选中的哪个 如果不填默认为0
      		    transitionEnd:function(indexArr, data){

      		    },
      		    callback:function(indexArr, data){
                  switch(data[0]){
                    case '小学':
                      that.birth_weight = 0;
                      break;
                    case '初中':
                      that.birth_weight = 1;
                      break;
                    case '高中':
                      that.birth_weight = 2;
                      break;
                    case '大专':
                      that.birth_weight = 3;
                      break;
                    case '本科':
                      that.birth_weight = 4;
                      break;
                    case '研究生':
                      that.birth_weight = 5;
                      break;
                    case '博士':
                      that.birth_weight = 6;
                      break;
                  }
                  // console.log(2,this.birth_height);
                  // console.log(2,this.birth_weight);
      		    }
      		});
      },
			saveChild:function(){
        // console.log(this.birth_height);
        // console.log(this.birth_weight);
        // return;
				var name = $('.childrenName').val();
				var birthday = $('#demo_date').val();
				if(name==''){
					alert1('请输入孩子姓名');
					return;
				}
				if(this.sex==''){
					alert1('请选择孩子性别');
					return;
				}
				if(birthday==''){
					alert1('请选择孩子出生日期');
					return;
				}
				// if($('.birth_week').val()==''){
				// 	alert1('请填写孕周');
				// 	return;
				// }
				// if($('.birth_weight').val()==''){
				// 	alert1('请填写孩子体重');
				// 	return;
				// }
				// if($('.birth_height').val()==''){
				// 	alert1('请填写孩子身高');
				// 	return;
				// }


        //小美医生
        if(this.living_place==''){
          alert1('请选择居住地');
          return;
        }
        if(this.birth_weight===''){
        	alert1('请填选择母亲受教育程度');
        	return;
        }
        if(this.birth_height===''){
        	alert1('请填选择父亲受教育程度');
        	return;
        }

				if(this.id===''){
					var url = 'institutions/'+sessionStorage.getItem('insituation')+'/users/'+this.children.openid+'/children';//+ this.children.data[0].openid
				}else{
					var url = 'institutions/'+sessionStorage.getItem('insituation')+'/users/'+this.children.openid+'/children/'+this.children.children.data[this.id].openid;
				}

				var that = this;
				// http.post(url+'?openid='+this.children.openid+'&name='+name+'&birthday='+birthday+'&birth_week='+$('.birth_week').val()+'&sex='+this.sex+'&birth_height='+$('.birth_height').val()+'&birth_weight='+$('.birth_weight').val()+'&role='+this.role).then(function(res){
				http.post(url+'?openid='+this.children.openid+'&name='+name+'&birthday='+birthday+'&sex='+this.sex+'&birth_height='+this.birth_height+'&birth_weight='+this.birth_weight+'&living_place='+this.living_place).then(function(res){
          if(res.data.status_code==422){
						alert1('编辑失败');
					}else{
						localStorage.setItem('user',JSON.stringify(res.data.data));
						that.$router.push({name:'userinfo'});
					}
				}).catch(function(res){
					if(that.children.children.data.length!=0){
						alert1('修改失败');
					}else{
						alert1('添加失败');
					}
				})
			}
		},
		mounted:function(){
      $('#demo_date').val(this.birthday);
			this.trigger1();
      this.trigger2();
      this.trigger3();
      this.trigger4();
			$('#demo_date').mobiscroll().date({
	            theme: "ios",
	            mode: "scroller",
	            display: "bottom",
	            dateFormat:"yyyy-mm-dd",
	            lang: "zh"
	        });
		},
		components: {
			bottomBar
		},
	}
</script>

<style scoped>
	.userWrapper {
		padding-bottom: 1.5rem;
	}

	.white {
		height: 1rem;
		padding: 0.2rem;
		line-height: 0.4rem;
		/*border-bottom: 1px solid #EEEEEE;*/
		/*text-align: center;*/
		color: #e34e42;
		font-size: 0.24rem;
	}

	.info-list {
		height: 0.80rem;
		border-bottom: 1px solid #EEEEEE;
		line-height: 0.80rem;
		padding-right: 0.20rem;
		font-size: 0.24rem;
		padding-left: 0.20rem;
	}

	.info-desc {
		color: RGBA(102, 102, 102, 0.8);
	}

	.icon-you {
		color: RGBA(153, 153, 153, 0.8);
	}

	.info-input {
		width: 3rem;
		color: RGBA(51, 51, 51, 0.8);
		height: 0.80rem;
		text-align: right;
		/*background: #fff;*/
	}

	.save-children {
		width: 2.40rem;
		height: 0.60rem;
		line-height: 0.60rem;
		background: #26a2ff;
		color: #fff;
		text-align: center;
		font-size: 0.24rem;
		border-radius: 0.50rem;
		margin: 0.30rem auto;
	}
</style>



// WEBPACK FOOTER //
// src/pages/addchild.vue